'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _createAccountForm = require('./create-account-form');

var _createAccountForm2 = _interopRequireDefault(_createAccountForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CreateAccount = _react2['default'].createClass({
    displayName: 'CreateAccount',


    propTypes: {
        'header': _react2['default'].PropTypes.string.isRequired,
        'googleOpenIdUrl': _react2['default'].PropTypes.string,
        'isFromApiPricing': _react2['default'].PropTypes.bool,
        'isInline': _react2['default'].PropTypes.bool,
        'isVertical': _react2['default'].PropTypes.bool, // only for inline
        'inlineSideText': _react2['default'].PropTypes.string,
        'tabOffset': _react2['default'].PropTypes.number,
        'signupForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'signupUrl': _react2['default'].PropTypes.string,
        'redirectUrl': _react2['default'].PropTypes.string,
        'recoverPasswordForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object, // Serialized sfForm
        'hideRememberMe': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'signupUrl': '/account/signUp'
        };
    },

    getInitialState: function getInitialState() {
        return {
            'password': '',
            'emailAddress': '',
            'isProcessing': false,
            'isInline': false,
            'isVertical': false
        };
    },

    componentDidMount: function componentDidMount() {
        if (!this.props.isInline) {
            $(document).foundation();
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!nextProps.isInline) {
            $(_reactDom2['default'].findDOMNode(this)).closest('.reveal-modal').foundation('reveal', 'open');
        }
    },

    render: function render() {
        return _jsx('div', {}, void 0, _jsx(_createAccountForm2['default'], {
            header: this.props.header,
            buttonText: this.props.buttonText,
            isInline: this.props.isInline,
            isVertical: this.props.isVertical,
            inlineSideText: this.props.inlineSideText,
            googleOpenIdUrl: this.props.googleOpenIdUrl,
            redirectUrl: this.props.redirectUrl,
            isFromApiPricing: this.props.isFromApiPricing,
            planId: this.props.planId,
            tabOffset: this.props.tabOffset,
            fields: this.props.signupForm.fields,
            values: this.props.signupForm.values,
            namespace: this.props.signupForm.namespace,
            action: this.props.signupUrl,
            recoverPasswordForm: this.props.recoverPasswordForm,
            loginForm: this.props.loginForm,
            hideRememberMe: this.props.hideRememberMe
        }));
    }
});

module.exports = CreateAccount;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/create-account.jsx
 ** module id = 748
 ** module chunks = 0
 **/